import { environment } from './environment';

/** On localhost ng serve, route API calls through proxy.conf.json to avoid CORS. */
export function resolveApiUrl(configuredUrl: string = environment.apiUrl): string {
  if (environment.production || typeof window === 'undefined') {
    return configuredUrl;
  }

  const host = window.location.hostname;
  if (host !== 'localhost' && host !== '127.0.0.1') {
    return configuredUrl;
  }

  if (!configuredUrl.startsWith('http://') && !configuredUrl.startsWith('https://')) {
    return configuredUrl;
  }

  try {
    const parsed = new URL(configuredUrl);
    if (parsed.hostname === 'localhost' || parsed.hostname === '127.0.0.1') {
      return configuredUrl;
    }
  } catch {
    return configuredUrl;
  }

  return '/api/v1';
}
